// Centralized brand assets.
// LOGO_URL is the canonical Tecnografic logo (uploaded by client).

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_tecno-modern/artifacts/mv741ise_logo-1.png";
